export const filterOptionsType = {
    fromDB: "fromDB",
    fromJson: "fromJson"
}